export default __webpack_public_path__ + "static/media/vSxp.2e188a9d.svg";